import DataTable from 'datatables.net-react';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { CSVLink } from 'react-csv';
import ReactDOMServer from 'react-dom/server';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { TradeService } from '../../services/TradeService';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from '../components/customStyles';
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from '../components/ScriptDropdown';
import To from '../components/To';
import '../custom.css';
import { useLocation } from "react-router-dom";

function getFormattedDate() {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit format
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

function Trade() {
  
  const location = useLocation();
  const { page } = location.state || {};
  const [loading, setLoading] = useState(false); 
  const [trade, setTrade] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [calledFirstTime, setCalledFirstTime] = useState(false);
  const [status, setStatus] = useState(page && page === 'executed' ? 'EXECUTED' : page === 'pending' ? 'PENDING' : 'EXECUTED');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [showModalExecuted, setShowModalExecuted] = useState(false);
  const [selectedTradeExecuted, setSelectedTradeExecuted] = useState(null);
  const [modalTypeExecuted, setModalTypeExecuted] = useState(null);
  const [columnsBackup, setColumnsBackup] = useState([]);
  
  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache("allScripts");

 
  useEffect(() => {
    const dataToSubmit = {
      adminId: user.adminId,
      status: status
    };

    if(calledFirstTime) {
      setLoading(true);
      fetchData(dataToSubmit);
    }

  },[status]);


  const handleUpdate = () => {
    const updatedTrade = {
      orderId: selectedTrade.orderId || null,
      quantity: selectedTrade.quantity || null,
      lot: selectedTrade.lot || null,
      rate: selectedTrade.rate || null,
      adminId: user.adminId || null,
      device: selectedTrade.device || null,
      remark: selectedTrade.remark || null,
    };


    TradeService.editTable(updatedTrade)
      .then((resp) => {
        if (resp.code === 1) {
          Swal.fire({
            icon: "success",
            text: "Updated Successfully !",
            timer: 2000
          })
          handleManualRefresh();
        } else {
          Swal.fire({
            icon: "warning",
            text: resp.messages || "Something went to wrong!",
          })
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: error?.response?.data?.messages ||  "Network error!"
        });
      });

    handleClose();
  };

  const onLotchange= (e) => {
    if(selectedTrade.lot !== e.target.value) { 
      var lot1 = e.target.value > 0 ? e.target.value : 1;
      let updatedQty = selectedTrade.quantity; // Default to current qty
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedTrade.market){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedTrade.symbol.split(" ")[0] === symbol){
              updatedQty = lot1 * script[0].quantity;
            }
          })
        }
      });

      if( (/^\d*$/.test(updatedQty))) {
        setSelectedTrade({ ...selectedTrade, quantity: updatedQty, lot: lot1});
      } 
    }
  }

  const onQtychange= (e) => { 
    if(selectedTrade.quantity !== e.target.value) { 
      var qty1 = e.target.value > 0 ? e.target.value : 1;
      let updatedLot = selectedTrade.lot; 
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedTrade.market){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedTrade.symbol.split(" ")[0] === symbol){
              updatedLot = qty1 / script[0].quantity ;
            }
          })
        }
      });

      if((/^\d*$/.test(qty1))) {
        setSelectedTrade({ ...selectedTrade, quantity: qty1, lot: updatedLot});
      }
    }
  }

  const openModalForTrade = (tradeData) => {
    setSelectedTrade({ ...tradeData });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedTrade(null);
  };


  const handleUpdateExecuted = () => {
    const updatedTrade = {
      orderId: selectedTradeExecuted.executedOrderId || null,
      orderType: selectedTradeExecuted.orderType || null,
      quantity: selectedTradeExecuted.quantity || null,
      lot: selectedTradeExecuted.lot || null,
      rate: selectedTradeExecuted.rate || null,
      scriptId: selectedTradeExecuted.scriptId || null,
      adminId: user.adminId || null,
      device: selectedTradeExecuted.device || null,
      remark: selectedTradeExecuted.remark || null,
    };


    TradeService.editTableExecuted(updatedTrade)
      .then((resp) => {
        if (resp.code === 1) {
          Swal.fire({
            icon: "success",
            text: "Updated Successfully!",
          })
          handleManualRefresh();
        } else {
          Swal.fire({
            icon: "warning",
            text: resp.messages
          })
        }
      })
      .catch((error) => {
        console.error("Error updating trade data:", error);
        Swal.fire({
          icon: "warning",
          text: "Network Error!"
        })
      });

    
  };

  const handleDeleteClickExecuted = (tradeData) => {
    
    if(!tradeData.userName){
      return;
    }
    const deleteRequestData = {
      orderId: tradeData.orderId,
      adminId: user.adminId || null,
      device: tradeData.device || null,
      remark: tradeData.remark || null,
    };
   
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this trade?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete it!',
      cancelButtonText: 'No, Keep it',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        if (tradeData.executedOrderId) {
          TradeService.deleteDataExecuted(deleteRequestData)
            .then((resp) => {
              if (resp.code === 1) {
                setTrade((prevTrades) => prevTrades.filter((trade) => trade.orderId !== tradeData.executedOrderId));

                Swal.fire({
                  icon: "success",
                  text: "Deleted Successfully !",
                  timer: 2000
                })
                handleManualRefresh();

              } else {
                Swal.fire({
                  icon: "error",
                  text: resp.messages ||"Something Went to wrong !"
                })
              }
            })
            .catch((error) => {
              console.error('Error deleting trade:', error);
              Swal.fire({
                icon: "error",
                text: error?.response?.data?.messages ||  "Network error!",
              })
            });
        } else if (tradeData.orderId) {
          TradeService.deleteData(deleteRequestData)
            .then((resp) => {
              if (resp.code === 1) {
                setTrade((prevTrades) => prevTrades.filter((trade) => trade.orderId !== tradeData.orderId));

                Swal.fire({
                  icon: "success",
                  text: "Deleted Successfully !",
                  timer: 2000
                })
                handleManualRefresh();
              } else {
                Swal.fire({
                  icon: "error",
                  text: resp.messages || "Something Went to wrong !",
                })
              }
            })
            .catch((error) => {
              console.error('Error deleting trade:', error);
              Swal.fire({
                icon: "error",
                text: error?.response?.data?.messages ||  "Network error!",
              })
            });
        } else {
          Swal.fire({
            icon: "error",
            text: "Issue in the request, Please refresh page!",
          })
        }
      } 
    });

  };
  // };

  useEffect(() => {
    const deleteIcons = document.querySelectorAll('.icon-trash');

    deleteIcons.forEach((icon) => {
      icon.addEventListener('click', handleDeleteClickExecuted);
    });

    return () => {
      deleteIcons.forEach((icon) => {
        icon.removeEventListener('click', handleDeleteClickExecuted);
      });
    };
  }, [trade]);

  const handleEditClickExecuted = (tradeData) => {
      openModalForTrade(tradeData);
  };

  useEffect(() => {
  
    if (fromDate && toDate && !calledFirstTime) {
      setLoading(true);
      const dataToSubmit = {
        adminId: user.adminId,
        status,
        segment: selectedMarket,
        keyword: selectedScript,
        date: fromDate,
        endDate: toDate,
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);

  const fetchData = (dataToSubmit) => {
    TradeService.tradeSearch(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.trades.length > 0) {
          setTrade(resp.data.trades);
        } else {
          setTrade([]);
        }
      })
      .catch((error) => { });
  };
  const handleManualRefresh = () => {
    const dataToSubmit = {
      adminId: user.adminId,
      status,
      segment: selectedMarket,
      keyword: selectedScript,
      date: fromDate,
      endDate: toDate,
    };
    fetchData(dataToSubmit); 
  };

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };
  const handleScriptReset = () => {
    setSelectedScript(null);
  };


  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

  const handleOrderTypeChange = (selectedOption) => {
    setSelectedOrderType(selectedOption);
  };
  const option = [
    { value: 'market', label: ' Market' },
    { value: 'limit', label: 'Limit' },
  ];

  function getDeviceIcon(device) {
    return device != undefined ? (device == 'Browser' ? '../../../img/web.png' : device == 'IOS' ? '../../../img/iphone.png' : '../../../img/phone.png') : '../../../img/phone.png';
  }

  const [columns, setColumns] = useState([
    {
      title: "D",
      render: (data, type, full, meta) => {
        const deviceIcon = getDeviceIcon(full.device);  
        const userAgent = full.userAgent;  
       
        return (
          `<img 
            style="filter: invert(1) brightness(0); cursor: pointer;" 
            src="${deviceIcon}" 
            height="15px"
            weight="15px"
            class="icon" 
            title="${userAgent ? userAgent : full.device ? full.device : ''}" />` 
        );
      },
    },
    { title: 'TRADE BY', data: 'tradeBy', className: "text-nowrap page-wrapper"  },
    { title: 'O-TIME', data: 'orderTime',  className: "text-nowrap page-wrapper"},
    { title: 'E-TIME', data: 'executedDate', className: "text-nowrap page-wrapper"},
    { title: 'NAME', data: 'userName', className: "text-nowrap page-wrapper"  },
    { title: 'MARKET', data: 'orderType', className: "text-nowrap page-wrapper" ,
      render: (data, type, full, meta) => full.orderType.toUpperCase()
     },
    { title: 'SYMBOL', data: 'symbol' },
    {
      title: 'TYPE',
      render: (data, type, full, meta) => {
        return full.orderType.startsWith('Buy') ? 'B' : 'S';
      },
    },
    { title: 'LOT', data: 'lot' },
    { title: 'QTY', data: 'quantity' },
    {
      title: 'O-PRICE', 
      data: 'rate', 
      render: (data, type, full, meta) =>
        ReactDOMServer.renderToString(<NumberFormatter number={full.rate} />),
    },
    {
      title: 'NET PRICE', 
      render: (data, type, full, meta) =>
        ReactDOMServer.renderToString(<NumberFormatter number={full.netRate != null ? full.netRate : full.rate} />),
    },
    {
        title: 'MODIFY',
        render: (data, type, full, meta) => {
          const orderId = full.status === 'PENDING' ? full.orderId : full.executedOrderId;
          if (!orderId) return null;
          const safeData = encodeURIComponent(JSON.stringify(full));
          return `
            <i class="me-3 fa fa-pencil icon-pencil" data-id="${orderId}" data-full='${safeData}' style="cursor: pointer"></i>
          `;
        },
    },
    {
      title: 'CANCEL',
      render: (data, type, full, meta) => {
        const orderId = full.status === 'PENDING' ? full.orderId : full.executedOrderId;
        if (!orderId) return null;
        const safeData = encodeURIComponent(JSON.stringify(full));
        return `
          <i class="icon-trash fa fa-trash" 
              data-id="${orderId}"  
              data-full='${safeData}' 
              style="cursor: pointer; color: red">
          </i>
        `;
      },
    },
    { 
      title: 'STATUS', 
      data: 'status' 
    },
    { 
      title: 'IP', 
      render: (data, type, full, meta) => {
        const ip = full.ip;
        if (!ip) return null; 
        return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
      },
    },
  ]);
  
  const initializeColumn = () => {
    if (user?.adminType !== 'SUPER_ADMIN' ) {
      if(status === 'EXECUTED') {
        setColumnsBackup(columns);
        setColumns((prevColumns) =>
          prevColumns.filter((col) => col.title !== 'MODIFY' && col.title !== 'CANCEL')
        );
      } else{
        setColumns(columnsBackup);
      }
    }
  }

  useEffect(() => {
    initializeColumn();
  }, [status]);

  const handleReset = () => {
    
    setSelectedMarket( null );
    setSelectedScript(null);
    setSelectedOrderType(null);
    setSelectedAdmin(null);
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);

  };



  const options = {
    paging: true,
    searching: true,
    responsive: true,
    select: true,
    columnDefs: [
      {
        targets: 1, width: '10%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      },
      {
        targets: 2, width: '10%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      },
      {
        targets: 3, width: '10%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      },
       {
        targets: 4, width: '10%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      },
      {
        targets: 5, width: '10%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      },
      {
        targets: 6, width: '15%', createdCell: (cell) => {
          cell.style.whiteSpace = 'nowrap';
        }
      }
    ]
  };
  const handleSubmit = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      status: status,
      segment: selectedMarket,
      keyword: selectedScript,
      date: fromDate,
      endDate: toDate
    };


    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }



    TradeService.tradeSearch(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1) {
          if (resp.data.trades.length > 0) {
            setTrade(resp.data.trades);
          } else {
            setTrade([]);
          }
        } else {
          setTrade([]);
        }
      }).catch((error) => {

      });

  };

  const headers = [
    { label: 'Device', key: 'device' },
    { label: 'Client', key: 'userName' },
    { label: 'Symbol', key: 'symbol' },
    { label: 'Order Type', key: 'orderType' },
    { label: 'B/S', key: 'type' },
    { label: 'Lot', key: 'lot' },
    { label: 'Qty', key: 'quantity' },
    { label: 'Order Price', key: 'rate' },
    { label: 'Net Price', key: 'netRate' },
    { label: 'Status', key: 'status' },
    { label: 'User IP', key: 'ip' },
    { label: 'Order Time', key: 'orderTime' },
    { label: 'Execute', key: 'executedDate' },
    { label: 'Added By', key: 'tradeBy' },
  ];

  const filename = `Trade_(${getFormattedDate()}).csv`;

  return (

    <div className='container-fluid'>

      <Card className='mt-2'>
        <Card.Body>
          <Row>
            <Col sm={2}>

              {['radio'].map((type) => (
                <div key={`inline-${type}`}>
                  <Form.Check
                    inline
                    label="PENDING ORDERS"
                    className='h6 fss-05'
                    name="group1"
                    type={type}
                    id={`inline-${type}-1`}
                    checked={status === 'PENDING'}
                    onChange={() => setStatus('PENDING')}

                  />
                </div>
              ))}


              <div>
                {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                    <Form.Check
                      defaultChecked
                      inline
                      className='h6 fss-05'
                      label="EXECUTED ORDERS"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={status === 'EXECUTED'}
                      onChange={() => setStatus('EXECUTED')}
                    />
                  </div>
                ))}
              </div>



              <div>
                {['radio'].map((type) => (
                  <div key={`inline-${type}`}>
                    <Form.Check
                      inline
                      className='h6 fss-05'
                      label="CANCEL ORDERS"
                      name="group1"
                      type={type}
                      id={`inline-${type}-1`}
                      checked={status === 'CANCELLED'}
                      onChange={() => setStatus('CANCELLED')}
                    />
                  </div>
                ))}
              </div>
            </Col>

            <Col>
              <Row>


                <Col sm={1} style={{ marginRight: 35 }}>
                  <b className='fss-05'>FROM</b><br />
                  <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                </Col>

                <Col sm={1} className=' me-5'>
                  <b className='fss-05'>TO</b><br />
                  <To toDate={toDate} setToDate={handleToDateChange} />
                </Col>


                <Col className='ms-3'>
                  <b className='fss-05'>MARKET</b>
                  <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset}

                  />
                </Col>

                <Col >
                  <b className='fss-05'>SCRIPT NAME</b>
                  <ScriptDropdown
                    allScripts={allScripts}
                    selectedMarket={selectedMarket}
                    onScriptChange={handleScriptChange}
                  />

                </Col>
                <Col  >
                  <b className='fss-05'>ORDER TYPE</b>
                  <Select
                    options={option}
                    value={selectedOrderType}
                    onChange={handleOrderTypeChange}
                    className='text-black'
                    placeholder="Select"
                    isSearchable={true}
                    theme={the} styles={customStyles}
                    isClearable
                  />                </Col>


              </Row>

              <Row>
                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col className='col-3'>
                      <b className="fss-05">ADMIN</b>
                      <AdminDropdown
                        adminId={user.adminId}
                        setSelectedOption={setSelectedAdmin} />
                    </Col>
                  </> : ""}

                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col className='col-3'>
                      <b className="fss-05">MASTER</b>
                      <MasterDropdown
                        adminId={user.adminId}
                        selectedAdmin={selectedAdmin}
                        setSelectedOption={setSelectedMaster}
                        setSelectedMaster={setSelectedMaster}
                        setSelectedBrokerId={setSelectedBrokerId}

                      />
                    </Col>
                  </> : ""}

                {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
                  <>
                    <Col className='col-3'>
                      <b className="fss-05">BROKER</b>
                      <BrokerDropdown
                        selectedAdmin={selectedAdmin}
                        selectedMaster={selectedMaster}
                        setSelectedOption={setSelectedBrokerId}
                        setSelectedBrokerId={setSelectedBrokerId}
                        setSelectedSubBrokerId={setSelectedSubBrokerId}
                      />
                    </Col>
                  </> : ""}



                <Col className='col-3'>
                  <b className="fss-05">CLIENT</b>
                  <ClientDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    selectedBrokerId={selectedBrokerId}
                    setSelectedOption={handleSelectedClientChange}
                  />

                </Col>

                <Col className='mt-4 '>
                  <Button variant="success" size="sm" className='me-1' onClick={handleSubmit}>
                    <b className='h6 small'> Find Trade</b>
                  </Button>

                  <Button variant="secondary" size="sm" className='me-1' onClick={handleReset}>
                    <b className='h6 small'>Clear Search</b>
                  </Button>

                  <CSVLink
                    data={trade} 
                    headers={headers} 
                    filename={filename}
                    className="btn btn-secondary btn-sm"
                  >
                    <b className='h6 small'>Export</b>
                  </CSVLink>
                </Col>
              </Row>
            </Col>
          </Row>
            <div>
              <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title className="modal-title-center">Trade Details</Modal.Title>

                </Modal.Header>
                <Modal.Body>

                  {selectedTrade ? (
                    <>
                        <Row >
                            <Col sm={2} md={2} xl={2}>
                              <b className='fss-08 me-2'>USER :</b>
                            </Col>

                            <Col xl={8} md={8} xs={8}>
                              <b className='fss-08 ms-4'> {selectedTrade.userName} </b>
                            </Col>
                        </Row>
                        <Row className='mt-1'>
                          <Col xl={2} md={2} xs={2}>
                              <b className='fss-08'>SYMBOL :</b>
                            </Col>
                            <Col xl={8} md={8} xs={8}>
                              <b className='fss-08 ms-4'>{selectedTrade.symbol}</b>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={6}>
                              <Row className='mt-2'>
                              <Col sm={3} md={5} xs={5}>
                                <b className='fss-08'>LOT :</b>
                              </Col>
                              <Col>
                                <input
                                  type="number"
                                  value={selectedTrade.lot || ''}
                                  onChange={(e) => onLotchange(e)}
                                  className="form-control ms-1 fss-08 bg-light text-black"
                                />
                              </Col>
                              </Row>
                            </Col>

                            <Col sm={6}>
                              <Row className='mt-2'>
                                <Col xl={4} md={4} xs={4}>
                                  <b className='fss-08'>QTY :</b>
                                </Col>
                                <Col xl={8} md={8} xs={8}>
                                {selectedTrade.market === "MCX" ?
                                  <input
                                    type="number"
                                    value={selectedTrade.quantity || ''}
                                    className="form-control fss-08 bg-light text-black"
                                    readOnly={true}
                                  /> : 
                                  <input
                                    type="number"
                                    value={selectedTrade.quantity || ''}
                                    onChange={(e) => onQtychange(e)}
                                    className="form-control fss-08 bg-light text-black"
                                  />
                                }
                                </Col>
                              </Row>
                           </Col>
                           </Row>
                           <Row>
                            <Col  xl={6} md={6} xs={6}>
                              <Row className='mt-2'>
                                <Col  xl={5} md={5} xs={5}>
                                  <b className='fss-08 text-nowrap'>ORDER PRICE: </b>
                                </Col>
                                <Col xl={7} md={7} xs={7}>
                                  <input
                                    type="number"
                                    value={selectedTrade.rate || ''}
                                    onChange={(e) =>
                                      setSelectedTrade((prevState) => ({
                                        ...prevState,
                                        rate: e.target.value,
                                      }))
                                    }
                                    className="form-control ms-1 fss-08 bg-light text-black"
                                  />
                                </Col>
                              </Row>
                            </Col>
                           </Row>
                      <Row >
                        <Col xl={2} md={2} xs={2} className='mt-2'>
                          <b className='fss-08'>REMARK:</b>
                        </Col>
                        <Col xl={8} md={8} xs={8}>
                          <Form.Control
                            type="text"
                            className="mt-2 ms-4 text-black bg-white custom-placeholder fss-08"
                            placeholder="Remark"
                            name="remark"
                          />
                        </Col>
                      </Row>
                    </>
                  ) : ''}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                  <Button variant="success" size='sm' onClick={handleUpdate}>
                    Update
                  </Button>
                  <Button variant="danger" size='sm' onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

            </div>

          {modalType === 'EXECUTED' && (
            <div>
              <Modal show={showModalExecuted} >
                <Modal.Header closeButton>
                  <Modal.Title className="modal-title-center">Trade Details</Modal.Title>

                </Modal.Header>
                <Modal.Body>

                  {selectedTradeExecuted ? (
                    <>
                      <Row >
                        <Col sm={6} className='mt-1' >
                          <Row>
                            <Col sm={5}>
                              <b className='fss-06 me-2'>NAME :</b>
                            </Col>

                            <Col>
                              <b className='fss-05'> {selectedTradeExecuted.userName} </b>
                            </Col>
                          </Row>

                          <Row className='mt-1'>
                            <Col sm={5}>
                              <b className='fss-06  '>ORDER TYPE :</b>
                            </Col>
                            <Col>
                              <Form.Check
                                inline
                                className="fss-05 me-4"
                                name="orderType"
                                type="radio"
                                id="buyOrder"
                                label="Buy"
                                checked={selectedTradeExecuted.orderType.includes('Buy')}
                                onChange={() =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    orderType: prevState.orderType.startsWith('Sell')
                                      ? 'Buy' + prevState.orderType.split('-')[1]
                                      : 'Buy',
                                  }))
                                }
                              />

                              <Form.Check
                                inline
                                className="fss-05"
                                name="orderType"
                                type="radio"
                                id="sellOrder"
                                label="Sell"
                                checked={selectedTradeExecuted.orderType.includes('Sell')}
                                onChange={() =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    orderType: prevState.orderType.startsWith('Buy')
                                      ? 'Sell' + prevState.orderType.split('-')[1]
                                      : 'Sell',
                                  }))
                                }
                              />

                            </Col> </Row>
                          <Row className=''>
                            <Col sm={4}>
                              <b className='fss-06 '>TYPE :</b>
                            </Col>
                            <Col>
                              <Form.Check
                                inline
                                className="fss-05 me-2"
                                style={{ marginLeft: 21 }}
                                name="market"
                                type="radio"
                                id="marketOrder"
                                label="Market"
                                checked={selectedTradeExecuted.orderType === 'Buy-MP' || selectedTradeExecuted.orderType === 'Sell-MP'}
                                onChange={() =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    orderType: prevState.orderType.startsWith('Buy')
                                      ? 'Buy-MP'
                                      : prevState.orderType.startsWith('Sell')
                                        ? 'Sell-MP'
                                        : prevState.orderType,
                                  }))
                                }
                              />

                              <Form.Check
                                inline
                                className="fss-05"
                                name="market"
                                type="radio"
                                id="limitOrder"
                                label="Limit"
                                checked={selectedTradeExecuted.orderType === 'Buy-SL' || selectedTradeExecuted.orderType === 'Sell-SL'} // Check if selected market type is 'Limit'
                                onChange={() =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    orderType: prevState.orderType.startsWith('Buy')
                                      ? 'Buy-SL'
                                      : prevState.orderType.startsWith('Sell')
                                        ? 'Sell-SL'
                                        : prevState.orderType,
                                  }))
                                }
                              />
                            </Col>
                          </Row>
                          <Row className=''>
                            <Col sm={5}>
                              <b className='fss-06'>SYMBOL :</b>
                            </Col>
                            <Col>
                              <b className='fss-05'>{selectedTradeExecuted.symbol}</b>
                            </Col>
                          </Row>

                        </Col>

                        <Col sm={6}>
                          <Row>
                            <Col sm={3}>
                              <b className='fss-06'>LOT :</b>
                            </Col>
                            <Col>
                              <input
                                type="number"
                                value={selectedTradeExecuted.lot || ''}
                                onChange={(e) =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    lot: e.target.value,
                                  }))
                                }
                                className="form-control fss-05 bg-light text-black"
                              />
                            </Col>
                          </Row>

                          <Row className='mt-2'>
                            <Col sm={3}>
                              <b className='fss-06'>QTY :</b>
                            </Col>
                            <Col>
                              <input
                                type="number"
                                value={selectedTradeExecuted.quantity || ''}
                                onChange={(e) =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    quantity: e.target.value,
                                  }))
                                }
                                className="form-control fss-05 bg-light text-black"
                              />
                            </Col>
                          </Row>

                          <Row className='mt-2'>
                            <Col sm={3}>
                              <b className='fss-06'>ORDER PRICE </b>
                            </Col>
                            <Col>
                              <input
                                type="number"
                                value={selectedTradeExecuted.rate || ''}
                                onChange={(e) =>
                                  setSelectedTradeExecuted((prevState) => ({
                                    ...prevState,
                                    rate: e.target.value,
                                  }))
                                }
                                className="form-control fss-05 bg-light text-black"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="">
                        <Col sm={2}>
                          <b className='fss-07'>Remark:</b>
                        </Col>
                        <Col>
                          <Form.Control
                            type="text"
                            className="mt-2  text-black bg-white custom-placeholder fss-05"
                            placeholder="Remark"
                            name="remark"
                          />
                        </Col>
                      </Row>
                    </>
                  ) : ''}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                  <Button variant="success" size='sm' onClick={handleUpdateExecuted}>
                    Update
                  </Button>
                  <Button variant="danger" size='sm' >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}


        </Card.Body>
      </Card >

      <Card className='mt-1 mb-4'>
        <Card.Body className=' mb-4'>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
              <div className="d-flex align-items-center justify-content-center h-90">
                <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
            ) : (
              <DataTable
                id="tardeTable"
                key={columns.length}
                className="mt-1 table table-striped text-center bg-secondary-row fss-08 table-responsive"
                data={trade}
                options={{
                  ...options,
                  language: {
                    emptyTable: 'No Data Found',
                    lengthMenu: 'entries per page _MENU_',
                  },
                  rowCallback: function (row, data) {
                    if (data.type === 'B') {
                      $(row).addClass('buy-row');
                    }
                    if (data.type === 'S') {
                      $(row).addClass('sell-row');
                    }
                  },
                  drawCallback: function () {
                    $('.icon-pencil').off('click').on('click', function (e) {
                      const encodedData = $(this).attr('data-full');
                      if (encodedData) {
                        try {
                          const parsedData = JSON.parse(decodeURIComponent(encodedData));
                          handleEditClickExecuted(parsedData);
                        } catch (err) {
                          console.error('Failed to parse data-full', err);
                        }
                      }
                    });
                    $('.icon-trash').off('click').on('click', function (e) {
                      const encodedData = $(this).attr('data-full');
                      if (encodedData) {
                        try {
                          const parsedData = JSON.parse(decodeURIComponent(encodedData));
                          handleDeleteClickExecuted(parsedData);
                        } catch (err) {
                          console.error('Failed to parse data-full', err);
                        }
                      }
                    });
                  }
                }}
                columns={columns}

              />
            )}
          </div>
        </Card.Body>
      </Card>

    </div>
  );
}
export default Trade;